import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import OfficeSupplyOrder from '@/types/table/officeSupplyOrder';
import { OfficeSupplyData } from '@/api/generated/officeSupplyController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface OfficeSupplyOrderData extends OfficeSupplyOrder {
  officeSupplyList?: OfficeSupplyData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class OfficeSupplyOrderController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<OfficeSupplyOrderData>>(API_CONTEXT + '/office/officeSupplyOrder/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<OfficeSupplyOrderData>(API_CONTEXT + '/office/officeSupplyOrder/view', params, httpOptions);
  }
  static viewFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<OfficeSupplyOrderData>(API_CONTEXT + '/office/officeSupplyOrder/viewFlow', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/office/officeSupplyOrder/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/office/officeSupplyOrder/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/office/officeSupplyOrder/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/update', params, httpOptions);
  }
  static store(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/store', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/deleteBatch', params, httpOptions);
  }
  static listOfficeSupplyOrderDetails(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/listOfficeSupplyOrderDetails', params, httpOptions);
  }
  static listNotInOfficeSupplyOrderDetails(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/listNotInOfficeSupplyOrderDetails', params, httpOptions);
  }
  static addOfficeSupplyOrderDetails(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/addOfficeSupplyOrderDetails', params, httpOptions);
  }
  static deleteOfficeSupplyOrderDetails(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/deleteOfficeSupplyOrderDetails', params, httpOptions);
  }
  static deleteOfficeSupplyOrderDetailsList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/deleteOfficeSupplyOrderDetailsList', params, httpOptions);
  }
  static updateOfficeSupplyOrderDetails(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/updateOfficeSupplyOrderDetails', params, httpOptions);
  }
  static viewOfficeSupplyOrderDetails(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/office/officeSupplyOrder/viewOfficeSupplyOrderDetails', params, httpOptions);
  }
  static startOnlyOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/startOnly/OfficeOrderFlow', params, httpOptions);
  }
  static startWithBusinessKeyOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/startWithBusinessKey/OfficeOrderFlow', params, httpOptions);
  }
  static startAndTakeUserTaskOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/startAndTakeUserTask/OfficeOrderFlow', params, httpOptions);
  }
  static startAndSaveDraftOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/startAndSaveDraft/OfficeOrderFlow', params, httpOptions);
  }
  static submitUserTaskOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/submitUserTask/OfficeOrderFlow', params, httpOptions);
  }
  static viewTaskBusinessDataOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/office/officeSupplyOrder/viewTaskBusinessData/OfficeOrderFlow', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/office/officeSupplyOrder/viewHistoricTaskBusinessData/OfficeOrderFlow', params, httpOptions);
  }
  static listWorkOrderOfficeOrderFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeSupplyOrder/listWorkOrder/OfficeOrderFlow', params, httpOptions);
  }
}
